import { PausePhotoType } from '../../enums/pause-photo-type.enum';

export class MarkerPoint implements IMarkerPoint {
  public latitude: number = 0;
  public longitude: number = 0;
  public address?: string = null;
  public radius?: number = 0;
  public color?: string = null;

  constructor(latitude = 0, longitude = 0) {
    this.latitude = latitude;
    this.longitude = longitude;
  }
}

export interface IMarkerPoint {
  latitude: number;
  longitude: number;
  address?: string;
  radius?: number;
  color?: string;
}

export interface LatLng {
  lat: number;
  lng: number;
}

export interface PauseMarkerPoint {
  createdOn: string;
  name: string;
  latitude: number;
  longitude: number;
  resumeInfo: PauseMarkerPointResumeInfo;
  stepId: number;
  isPickup: boolean;
  photos?: PausePhotoMarker[];
}

export interface PausePhotoMarker {
  id: number;
  // Pre-signed URL, generated server side
  location: string;
  dateTime: string;
  photoType: PausePhotoType;
}

export interface PauseMarkerPointResumeInfo {
  elapsed: string;
  createdOn: string;
  name: string;
  photos?: PausePhotoMarker[];
}
